module.exports = __webpack_public_path__ + "img/cancelled.81c04b5d.gif";